.kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: var(--size-badge);
  min-width: var(--size-badge);
  padding: 0 var(--space-1);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  background: var(--color-surface);
  box-shadow: var(--shadow-1);
  color: var(--color-fg-muted);
  font-size: var(--text-xs);
  line-height: 1;
}
